import { useEffect } from 'react'


/**
 * @param {Function} callback
 * @param {Boolean} [withScrollToTop]
 */
const useHistoryBack = (callback, withScrollToTop) => (
  useEffect(() => {
    const handler = (event) => {
      const { state } = event

      if (typeof callback === 'function') {
        callback(state)
      }

      if (withScrollToTop && window && (window.scroll || window.scrollTo)) {
        try {
          window.scroll({
            top: 0,
            left: 0,
            behavior: 'smooth',
          })
        }
        catch (err) {
          window.scrollTo(0, 0)
        }
      }
    }

    window.addEventListener('popstate', handler)

    return () => {
      window.removeEventListener('popstate', handler)
    }
  }, [ callback, withScrollToTop ])
)


export default useHistoryBack
